import { bool, number, object, string } from "yup";
import { PremiumStructure } from "../../common/interfaces/enums/PremiumStructure";
import ProductType from "../../common/interfaces/enums/ProductType";
import { IQuoteSettings } from "../interfaces/form/IQuoteSettings";
import { ILifeQuoteClient } from "../interfaces/form/life/ILifeQuoteClient";
import { isSelected } from "./ValidationHelpers";

const client = object<ILifeQuoteClient>({
    isSelected: bool().notRequired().default(false),
    coverAmount: isSelected(
        number(),
        number()
            .positive("Cover amount must be greater than 0")
            .required("Please provide a life cover amount")
    )
});

const root = object<IQuoteSettings[ProductType.Life]>({
    premiumStructure: string<PremiumStructure>().required(
        "Please select a premium structure"
    )
});

export default {
    client,
    root
};
